import React, { Component } from 'react'
import { Row } from 'react-bootstrap'
import ReceiptModal from '../../../../../ui/modals/ReceiptModal'
import PurchaseHistoryDataTable from './PurchaseHistoryDataTable'
import DownloadReceiptModal from '../../../../../ui/modals/DownloadReceiptModal'

class PurchaseHistoryRow extends Component {
    static defaultProps = {
        data: [
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
            { name: 'receipt_20-20-2020', type: 'Gold Membership', date: '20/20/2020', payment: 'Monthly', amount: '$500', selected: false },
        ]
    }

    constructor(props) {
        super(props)

        this.state = {
            showModal: '',
            rows: props.data,
            clickedRow: null, // When the button click without select
            selectedRows: []
        }
    }

    render() {
        return (
            <div className="form-row purchase-history-form-row">
                {this.renderHeader()}
                {this.renderTable()}
                {this.renderModals()}
            </div>
        )
    }

    renderHeader() {
        return (
            <div className="purchase-history-form-row--header">
                <h4 className="form-group-title">Purchase History</h4>
            </div>
        )
    }

    renderTable() {
        const { rows, selectedRows } = this.state;
        const page = 1;
        const showPagination = rows.length > 30;
        console.log(selectedRows);
        
        return (
            <Row className="gutters-12">
                <PurchaseHistoryDataTable
                    error={null}
                    loading={false}
                    page={page}
                    showPagination={showPagination}
                    rows={this.formatter(rows)}
                    selectedRowsLength={selectedRows.length}
                    openReceiptModal={this.handleOpenReceiptModal}
                    downloadReceiptModal={this.handleDownloadReceiptModal}
                    downloadSelectedReceipt={this.handleDownloadSelectedReceipt}
                    handleRowSelect={this.handleRowSelect}
                    handleHeaderSelect={this.handleRowSelect}
                />
            </Row>
        )
    }

    renderModals() {
        const { showModal } = this.state;
        const { clickedRow, selectedRows } = this.state;
        const files = clickedRow ? [clickedRow] : selectedRows;

        return (
            <>
                <ReceiptModal
                    show={showModal === 'receipt-modal'}
                    onHide={() => this.setShowModal('')}
                />
                <DownloadReceiptModal
                    show={showModal === 'download-receipt-modal'}
                    onHide={() => this.setShowModal('')}
                    files={files}
                />
            </>
        )
    }

    // renderOld() {
    //     const { showModal } = this.state;

    //     return (
    //         <div className="form-row purchase-history-form-row">
    //             <Row>
    //                 <Col xl={12}>
    //                     <h4 className="form-group-title">Purchase History</h4>
    //                 </Col>
    //                 <Col xl={3} md={6}>
    //                     <InfoItem title="Account Type" text="Gold Membership" />
    //                 </Col>
    //                 <Col xl={2} md={6}>
    //                     <InfoItem title="Date" text="05/24/2019" />
    //                 </Col>
    //                 <Col xl={2} md={6}>
    //                     <InfoItem title="Payment Type" text="Credit Card" />
    //                 </Col>
    //                 <Col xl={2} md={6}>
    //                     <InfoItem title="Amount" text="$500" />
    //                 </Col>
    //                 <Col xl={{ span: 2, offset: 1 }} lg={6}>
    //                     <Button
    //                         variant="secondary"
    //                         className="form-row-btn lg"
    //                         size="xl"
    //                         onClick={() => this.setShowModal(true)}
    //                     >Receipt</Button>
    //                 </Col>
    //             </Row>
    //         </div>
    //     )
    // }

    handleOpenReceiptModal = (clickedRow) => {
        this.setState({
            showModal: 'receipt-modal',
            clickedRow
        });
    }

    handleDownloadReceiptModal = (clickedRow) => {
        console.log(clickedRow);

        this.setState({
            showModal: 'download-receipt-modal',
            clickedRow
        });
    }

    handleDownloadSelectedReceipt = () => {
        this.setState({
            showModal: 'download-receipt-modal',
            clickedRow: null
        });
    }

    handleRowSelect = (e, rows) => {
        this.setState({
            selectedRows: this.getSelectedRows(rows),
            rows
        })
    }

    setShowModal = (modal) => {
        this.setState({ showModal: modal });
    }

    getSelectedRows = rows => {
        return rows.filter(row => row.selected);
    }

    formatter = (data) => {
        return data.map((row, idx) => ({ ...row, id: idx }));
    }
}

export default PurchaseHistoryRow
